import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class DueDateInDaysLessThanZeroError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.due-date-in-days.less-than-zero');
    }
}
